import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Link } from 'react-router-dom'

export function Button({
  text,
  icon = null,
  width = 234,
  height = 69,
  fontSize = 'text-lg',
  textColor = 'text-white',
  bgColor = 'fill-[#363636]',
  hoverBgColor = null,
  onClick,
  type = 'button',
  to = null,
  ...rest // ⬅️ מאפשר העברת aria-label, title, role, וכו'
}) {
  const viewBox = '0 0 234 69'
  const pathData =
    'M4 16.1964C4.22989 16.2725 4.46012 16.3524 4.69054 16.4366C6.14298 16.9641 8.11196 17.9422 8.74171 19.0967C8.16288 16.8221 7.08123 14.8862 4.98019 13.3372C6.41246 14.3267 8.2892 15.0212 10.1785 15.7205L10.1786 15.7205C12.7721 16.6804 15.3894 17.6491 16.9134 19.4014C17.4961 20.0782 17.8266 20.7102 17.8646 21.4516C17.9712 17.7756 16.8371 11.9048 13.7035 9.22684C16.2376 10.194 18.161 11.75 19.0451 13.7871C19.281 11.9959 18.511 10.483 17.7251 8.93888C17.2516 8.00842 16.7722 7.06665 16.5038 6.04583C18.8184 7.37286 21.589 7.64622 24.1093 6.94504C21.8327 7.17923 20.7216 6.16059 19.887 4.57031H217.167C216.241 4.98885 215.327 5.46028 214.411 5.93321L214.41 5.93341C211.753 7.30426 209.072 8.68768 206.008 8.83204C204.828 8.88342 203.845 8.7746 202.887 8.38993C207.476 10.5136 215.531 12.9472 220.66 12.1356C218.027 13.4589 214.99 14.0057 211.922 13.5216C214.056 14.6916 216.397 14.9678 218.787 15.2497C220.227 15.4196 221.685 15.5916 223.125 15.9624C220.159 16.9241 218.272 18.807 217.756 21.0483C219.146 18.4667 222.456 19.0712 226.608 19.8296L226.608 19.8296C227.688 20.0269 228.825 20.2346 230 20.3993V46.4366C228.585 46.3951 227.123 46.303 225.611 46.0869C223.703 45.8179 221.008 45.1468 219.802 43.9516C221.408 46.464 223.461 48.462 226.543 49.7668C224.469 48.9548 221.998 48.592 219.511 48.2269C216.096 47.7256 212.65 47.2198 210.157 45.5408C209.2 44.8909 208.557 44.2333 208.209 43.3786C209.59 47.6866 213.316 54.2565 218.064 56.6309C214.715 56.1071 211.837 54.7518 209.973 52.5889C210.432 54.7319 211.948 56.3113 213.496 57.9232C214.429 58.8946 215.373 59.8778 216.104 61.0032C212.864 60.0078 209.524 60.3485 206.875 61.7651C210.025 60.7615 211.893 62.395 213.893 64.7852H20.7687C18.8073 64.1424 16.5702 64.1067 14.396 64.7852H14.3345C14.9349 63.8332 15.7139 62.997 16.4836 62.1709L16.4837 62.1708C17.7718 60.7882 19.034 59.4335 19.3892 57.6102C17.8413 59.4635 15.42 60.6406 12.5861 61.1164C16.578 59.0568 19.6355 53.4456 20.7392 49.776C20.4576 50.5048 19.9215 51.0689 19.1204 51.6294C17.0309 53.0777 14.1139 53.5391 11.2235 53.9964C9.11781 54.3294 7.02621 54.6603 5.2788 55.3688C7.87421 54.2326 9.58494 52.5176 10.908 50.3702C9.90296 51.3959 7.62649 51.9906 6.0111 52.2366C5.32942 52.3418 4.65913 52.417 4 52.4716V16.1964Z'
  
    const Wrapper = to ? Link : 'button'
    const wrapperProps = to
      ? { to, ...rest }
      : { type, onClick, ...rest }
  
    return (
      <div
        style={{ width: `${width}px`, height: `${height}px` }}
        className="relative overflow-hidden"
      >
        <Wrapper {...wrapperProps} className="relative w-full h-full group">
          {/* רקע SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox={viewBox}
            preserveAspectRatio="none"
            className="absolute top-0 left-0 w-full h-full"
          >
            <g filter="url(#filter0_d)">
              <path
                d={pathData}
                className={clsx(
                  'transition-colors duration-300',
                  bgColor,
                  hoverBgColor
                )}
              />
            </g>
            <defs>
              <filter
                id="filter0_d"
                x="0.3"
                y="0.870312"
                width="233.4"
                height="67.6148"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
              >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="1.85" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
  
          {/* תוכן – ממורכז */}
          <div className="relative flex gap-2 items-center justify-center w-full h-full mx-auto my-auto z-10">
            {icon &&
              (typeof icon === 'string' ? (
                <img
                  src={icon}
                  alt=""
                  role="presentation"
                  aria-hidden="true"
                  className="w-6 h-6"
                />
              ) : (
                <div className="w-6 h-6 flex items-center justify-center" aria-hidden="true">
                  {icon}
                </div>
              ))}
            <p
              className={clsx(
                'm-0 transition-colors duration-300',
                fontSize,
                textColor
              )}
            >
              {text}
            </p>
          </div>
        </Wrapper>
      </div>
    )
  }
  
  Button.propTypes = {
    text: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    width: PropTypes.number,
    height: PropTypes.number,
    fontSize: PropTypes.string,
    textColor: PropTypes.string,
    bgColor: PropTypes.string,
    hoverBgColor: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['button', 'submit', 'reset']),
    to: PropTypes.string,
  }
  